import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from '@app/services/order/order.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';

@Component({
  selector: 'manual-verify-dialog',
  templateUrl: './manual-verify.dialog.html',
  styleUrls: ['./manual-verify.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ManualVerifyDialog implements OnInit, OnDestroy {
  private destroy$ = new Subject<any>();
  @Output() onVerifyOrders = new EventEmitter();
  isOrdersVerified: boolean = false;
  selectedOption: DropdownOption;

  constructor(
    public dialogRef: MatDialogRef<ManualVerifyDialog>,
    private orderService: OrderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.orderService.ordersIsLoading.pipe(takeUntil(this.destroy$)).subscribe((loading: boolean) => {
      this.isOrdersVerified = loading;
    });
    this.selectedOption = this.data?.selectedOption;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  verifyOrders(): void {
    this.onVerifyOrders.emit();
  }
}
